<template>
  <div class="">
    <el-table
      size="mini"
      border
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      style="width: 100%"
      :data="list"
      :span-method="headSpanMethod"
    >
      <el-table-column
        align="center"
        :prop="item.valueKey"
        :label="item.label"
        v-for="(item, index) in headList"
        :key="index"
      >
        <template slot-scope="scope">
          <template v-if="item.valueKey === 'transPrice'">
            <price-blurring
              :price-display-type="priceDisplayType"
              :price="scope.row[item.valueKey] ? scope.row[item.valueKey] : '/'"
            />
          </template>
          <template v-else>
            {{ scope.row[item.valueKey] ? scope.row[item.valueKey] : '/' }}
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import PriceBlurring from "../../../../../common/priceBlurring";
export default {
  name: "transferPriceTable",
  components: {PriceBlurring},
  props:{
    // 转运报价列表
    list:{
      type:Array,
      default:()=>[],
    },
    // 转运报价header列表
    headList:{
      type:Array,
      default:()=>[
        {label:"共享仓始发城市",valueKey:"startCity",},
        {label:"目的地装柜城市",valueKey:"endCity",},
        {label:"计费单位",valueKey:"transUnit",},
        {label:"价格",valueKey:"transPrice",},
        {label:"币种",valueKey:"transCurrency",},
        {label:"备注",valueKey:"remark",},
      ],
    },
    // 价格显示类型，1：不显示  2：显示，默认不显示
    priceDisplayType:[String,Number],
  },
  methods:{
    /**
     * 合并规则
     * @param row
     * @param column
     * @param rowIndex
     * @param columnIndex
     * @returns {number[]}
     */
    headSpanMethod({ row, column, rowIndex, columnIndex }){
      return [1,1]
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/transferPriceTable/index.vue